export function getVideoScreenShot(file: File): Promise<Blob> {
  return new Promise(resolve => {
    const url = URL.createObjectURL(file)

    const video = document.createElement('video')
    function timeupdate() {
      if (snapImage()) {
        video.removeEventListener('timeupdate', timeupdate)
        video.pause()
      }
    }

    video.addEventListener('loadeddata', () => {
      const snapImageRes = snapImage()
      if (snapImageRes) video.removeEventListener('timeupdate', timeupdate)
    })

    function snapImage() {
      const canvas = document.createElement('canvas')
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight
      canvas
        .getContext('2d')
        ?.drawImage(video, 0, 0, canvas.width, canvas.height)

      const image = canvas.toDataURL()
      const success = image.length > 1000

      if (success) {
        canvas.toBlob(imageBlob => {
          video.src = ''
          if (imageBlob) resolve(imageBlob)
        }, 'image/jpeg')

        URL.revokeObjectURL(url)
      }

      return success
    }

    video.addEventListener('timeupdate', timeupdate)
    video.preload = 'metadata'
    video.src = url
    // Load video in Safari / IE11
    video.muted = true
    video.playsInline = true
    video.play()?.catch(e => {
      console.log('getVideoScreenShot > video.play | error:', e)
    })
  })
}
